export const scrollToanker = function () {
        // check if anker is in url
        if (window.location.hash) {
            // get anker without #
            const anchor = window.location.hash.slice(1);
            // find element with the id
            const targetElement = document.getElementById(anchor);
            // check if element is found
            if (targetElement) {
            // scroll to target
            targetElement.scrollIntoView({
                behavior: 'smooth', // scroll smoth
            });
            }
        }
    }